import { render, staticRenderFns } from "./TemplateEditContent.vue?vue&type=template&id=f2daf0ca&"
import script from "./TemplateEditContent.vue?vue&type=script&lang=js&"
export * from "./TemplateEditContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports